import React, { Component } from 'react';
import { translate } from 'react-i18next';

import Info from 'components/Info/Info';

import RequestService from 'services/RequestService';

import './InfoView.css';

declare var CONFIGURATIONS;

class InfoView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      group: {},
      loaded: false,
    };
  }

  componentWillMount = () => {
    const { block, unblock } = this.props;
    block();
    const name = window.location.href.split('/catalogocartoteca/info/')[1].trim();
    RequestService.getRequest(`${CONFIGURATIONS.ckan_url}/package_show?id=${name}`).then((res) => {
      const group = res.result.groups.filter((g) => g.name !== 'cartoteca')[0];
      this.setState({ loaded: true, data: res.result, group }, () => {
        unblock();
      });
    });
  }

  modifyImageUrl = (url) => {
    const newWidth = parseInt(url.split('&WIDTH=')[1].split('&')[0], 10) * 2;
    const newHeight = parseInt(url.split('&HEIGHT=')[1].split('&')[0], 10) * 2;
    return `${url.split('&WIDTH=')[0]}&WIDTH=${newWidth}&HEIGHT=${newHeight}&${url.split('&HEIGHT=')[1].split('&')[1]}`;
  }

  render() {
    const { group, data, loaded } = this.state;
    if (!loaded) {
      return(<div></div>);
    } else {
      let images = data.resources.filter((rr) => {
        return rr.resource_type === 'Previsualizacion';
      });

      let image = images[0];
      if (group.name !== 'cartografia-antigua') {
        image = data.resources.filter((rr) => {
          return rr.resource_type === 'PNG';
        })[0];
      } else if (data.signature.indexOf('ATL') > -1) {
        images = data.resources.filter((rr) => {
          return rr.resource_type === 'Miniatura';
        });

        image = images[0];
      }

      return (
        <div className='infoFullContainer'>
          <div className='bannerContainer' style={{ backgroundPosition: (data.signature.indexOf('DOC') > -1 || data.signature.indexOf('ATL') > -1) ? 'top' : 'center', backgroundImage: image !== undefined && group.name !== 'cartografia-antigua' ? `url(${this.modifyImageUrl(image.url)})` : image !== undefined && group.name === 'cartografia-antigua' ? `url(${image.url})` : 'unset' }}>
            <div>{(data.signature.indexOf('DOC') > -1 || data.signature.indexOf('ATL') > -1) ? 'Información de la obra' : 'Información del mapa'}</div>
          </div>
          <div className='breadCrumbs'>
            <p><a href='/catalogocartoteca/home'>Colecciones</a>&nbsp;&nbsp;/&nbsp;&nbsp;<a href={`/catalogocartoteca/search/${group.name}`}>{group.title}</a>&nbsp;&nbsp;/&nbsp;&nbsp;<span>{data.title}</span></p>
          </div>
          <div className='fileContainer'>
            <Info variant={group.name} data={data} />
          </div>
        </div>
      );
    }
  }
}

export default translate()(InfoView);
